import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  Inject,
  Optional,ChangeDetectorRef, AfterViewChecked, Input
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs";
import { ContactsUtils } from "./ContactsUtils";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";

import { PDFfile } from "src/app/device/PDFfile";
import { Router } from "@angular/router";
import { TraslateService } from "src/app/traslate.service";

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexAnnotations,
  ApexStroke,
  ApexMarkers,
  ApexGrid,
  ApexLegend,
} from "ng-apexcharts";
import { TooltipArea } from "@swimlane/ngx-charts";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ErrorStateMatcher } from "@angular/material/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SelectionModel } from "@angular/cdk/collections";

export type ChartOptions = {
  series: any;
  chart: any;
  xaxis: any;
  yaxis: any;
  title: any;
  fill: any;
  dataLabels: any;
  tooltips: any;
  annotations: any;
  stroke: any;
  markers: any;
  colors: string[];
  grid: any;
  legend: any;
};

export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}

export interface dataRep {
  label: number;
  value: number;
}

export interface dataRep2 {
  value: number;
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit , AfterViewChecked  {
  matcher = new MyErrorStateMatcher();
  myModel = false;
  chartOptions16: any;
  chartOptions17: any;
  manualPage: number = 0;
  pageSize1: any;
  pageSize = 15;
  lengthpage: number;
  pageNum: any;
  manualPage1: number;
  lengthTotal: any;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [15, 30, 100];
  public dateTime: Date;
  index2: any = 15;
  dd: any = 0;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  itemSelect2: any;
  hiddenContenu: string = "false";
  range: string;
  filterValue: string;
  repos2: PeriodicElementfilter[];
  URL: RequestInfo;
  refrech1: number = 2017;
  dt: any;
  days: any;
  finalDate: any;
  hiddenDetails: boolean = false;
  dtformt: string = "M/d/yyyy";
  @ViewChild("paginator", { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  jj: string;
  tblhidden: string;
  typeMessage: string;
  dataSourcee: any;
  ELEMENT_DATAFILTER: PeriodicElementfilter[];
  dataSource: MatTableDataSource<PeriodicElementfilter>;
  getdt: string;
  panelOpenState = false;
  repos: any;
  partnercompanyrevendeur:boolean =false
  selected: boolean = false;

  contactList: any = "";
  tableDataSourceContact: any = [];
  partnercompany: boolean;
  idSelected: any;

  id: any;
  first_name: any;
  last_name: any;
  gsm_number: any;
  email: any;
  hiddenItemClick: any = 0;

  submitStatus: boolean;

  showadd: boolean = false;

  series1: any = [];
  ff: any = null;

  series3: any = [];
  series4: any = [];
  fff: any = [];
  vv: any;
  showedit: boolean;
  contactListPost: boolean;
  searchbyname  : any ="" ;
  filtre = '';
  reseller_id: any;
  registerFormContact: FormGroup;
  registerFormContactupdate: FormGroup;
  selection = new SelectionModel(true, []);
  listItems: any =[];
  lengthSelected: number;
  nameSelected: any;
  @Input() cValue;

  checkboxLabel(row?: any): string {

    if (!row) {


      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }

    this.listItems =this.selection.selected
    this.lengthSelected = this.listItems.length


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }
  isAllSelected() {

    const numSelected = this.selection.selected.length;

    const numRows = this.dataSource?.data?.length;

    return numSelected === numRows;
  }


  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    this.updateManualPage2(this.index2);
    this.getContact(15,1);
    this.registerFormContact = this.formBuilder.group({
      // tslint:disable-next-line:quotemar
      last_name: [
        "",
        {
          validators: [
            Validators.required,
            Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
          ],
          updateOn: "change",
        },
      ],
      email: [
        "",
        {
          validators: [Validators.required, Validators.email],
          updateOn: "change",
        },
      ],
      gsm_number: [],
      first_name: [
        "",
        {
          validators: [
            Validators.required,
            Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
          ],
          updateOn: "change",
        },
      ],
      company_id: [],
      created_at: [],
      created_by: [],
      id: [],
      updated_at: [],
    });

    this.registerFormContactupdate = this.formBuilder.group({
      // tslint:disable-next-line:quotemar
      last_name: [
        "",
        {
          validators: [
            Validators.required,
            Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
          ],
          updateOn: "change",
        },
      ],
      email: [
        "",
        {
          validators: [Validators.required, Validators.email],
          updateOn: "change",
        },
      ],
      gsm_number: [],
      first_name: [
        "",
        {
          validators: [
            Validators.required,
            Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
          ],
          updateOn: "change",
        },
      ],
      company_id: [],
      created_at: [],
      created_by: [],
      id: [],
      updated_at: [],
    });
  }

  getContact(currentSize ,offset,) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.contactList = true;
    this.spinnercontact.show();
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts"+'?page='+offset + '&name='+this.searchbyname,
        requestOptions
      )
      .subscribe(
        (response : any) => {
          var listContacts: any = response.data;
          this.lengthTotal = response?.total;
          console.log(this.lengthTotal)
          if (currentSize == 0 ){
            listContacts.length =1 ;
          }else {
            listContacts.length =currentSize ;
          }

          this.repos = response?.data;
          this.repos.push(...listContacts);
          this.repos.length = response?.total;
          //console.log('gfhfghgfht'+this.repos)

          this.contactList = this.repos;


          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource._updateChangeSubscription();

          this.dataSource.paginator = this.paginator;
          // this.tableDataSourceContact = this.repos;
          this.dataSource.sort = this.sort;

          // this.dataSource.filterPredicate = this.createFilter();
          this.spinnercontact.hide();
          this.contactList = false;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });

          this.spinnercontact.hide();
        }
      );
  }

  pageChanged(event) {
  let pageIndex = event.pageIndex;
  let pageSize = event.pageSize;

  let previousIndex = event.previousPageIndex;

  let previousSize = pageSize * pageIndex;
    this.getContact(
      previousSize,
      (pageIndex+1).toString()
    );
  }

  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      //console.log(searchTerms);

      let nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          for (const col in searchTerms) {
            searchTerms[col].trim().toLowerCase().split(' ').forEach(word => {
              if(data[col] != null) {
                data[col].toString().toLowerCase() === searchTerms[col].trim().toLowerCase()

              }
              if ( data[col] != null && data[col].toString().toLowerCase() === searchTerms[col].trim().toLowerCase() && isFilterSet) {
                found = true
              }
            });
          }
          return found
        } else {
          return true;
        }
      }
      return nameSearch()
    }
    return filterFunction
  }

  resetContacts(){
    this.searchbyname= "";
    this.getContact(  15,1,);
  }

  modif_cancel() {
    this.registerFormContact.reset();
  }

  submitForm() {
    if (this.registerFormContact.invalid) {
      return;
    }
    Object.values(this.registerFormContact).forEach((val) => {
    });
    this.submitStatus = true;

    this.contactListPost = true;
    this.spinnercontact.show();
    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts",
        this.registerFormContact.value
      )
      .subscribe(
        (data) => {
          var resp: any = data;
          if (resp.status == 200) {
            this.spinnercontact.hide();
            this.contactListPost = false;

            Swal.fire({
              position: "center",
              title: "Contact enregistré avec succès!",
              showConfirmButton: false,
              timer: 1000,
            });
            let ref = document.getElementById('cancel-add')
            ref?.click()

            this.getContact(15,1);
          } else {
            this.spinnercontact.hide();
            this.contactListPost = false;

            Swal.fire({
              text: resp.message.join("<br>"),
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });

          this.spinnercontact.hide();
        }
      );
  }

  async afficher_details(e) {
    this.itemSelect =e;
    this.selectedRowIndex = e.id;
    this.hiddenDetails = true
    this.last_name=e.last_name;
    this.first_name=e.first_name;
    this.gsm_number=e.gsm_number;
    this.email=e.email;
      const { value: formValues } = await Swal.fire({
        border:' 1px solid #262853',
        width: 900,
        opacity: 1,
        background: 'rgba(238,238,238,0)',
        showConfirmButton: false,
        allowOutsideClick: () => {
          this.arr = []
          this.listItems = []
          this.selection.clear()
          return true;
        },
        html:
        '<div style="background: rgba(255, 255, 255, 0.8);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(13.7px);'+
        '-webkit-backdrop-filter: blur(8px);border: 1px solid rgba(255, 255, 255, 0.22);  border: 1px solid #262853;border-radius: 25px;">'+
        '<div>'+
        '<h1 class="pb-4" style="color :#262756;margin-right: 50%;margin-top: 5%;" > <strong>  Détails d\'utilisateur  </strong> <h1>'+
        '</div>'+
        '<table class="swal" style="color :#262756;margin-left: 15%; text-align: left; margin-bottom: 10%;">'+
         ' <tr style="height: 24px !important;" ><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Prénom : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> '+this.first_name +'</h3></td></tr>'+
         ' <tr style="height: 24px !important;" ><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Nom : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> '+this.last_name +'</h3></td></tr>'+
         ' <tr style="height: 14px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Email : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> '+this.email +'</h3></td></tr>'+
         ' <tr style="height: 4px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Numero Telephone : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> '+this.gsm_number +'</h3></td></tr>'+
        '</table>'+
        '</div>',
      });
  }

  arr:any=[]
  Delete_contact() {

    for(var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
  }
      Swal.fire({
        title: "Voulez-vous supprimer ce contact?",
        showCancelButton: true,
        confirmButtonColor: '#262756',
        cancelButtonColor: "#e05a61",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui",
      }).then((result) => {
        if (result.isConfirmed) {
          this.contactListPost = true;
          this.spinnercontact.show();
          this.http
            .delete(environment.apiUrl + "/contacts/" +JSON.stringify(this.arr)
            )
            .subscribe(
              (response) => {
                var resp: any = response;
                if (resp.status == 200) {
                  //console.log(response)
                  this.spinnercontact.hide();
                  this.contactListPost = false;
                  this.getContact(15,1);
                  this.arr = []
                  this.selection.clear();
                  /*                   this.selected = false;
 */
                  Swal.fire("", resp.message);
                } else if (resp.status == false) {
                  Swal.fire({
                    html: resp.message.join("<br>"),
                    showCancelButton: true,
                    confirmButtonColor: '#262756',
                    cancelButtonColor: "#e05a61",
                    cancelButtonText: "Annuler!",
                    confirmButtonText: "Confirmer!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.http
                        .delete(
                          environment.apiUrl +
                            "/contacts/" +
                            this.selectedRowIndex
                        )
                        .subscribe(
                          (response) => {
                            if (resp.status == 200) {
                              this.spinnercontact.hide();
                              this.contactListPost = false;
                              this.getContact(15,1);
                              Swal.fire("", resp.message);
                            }
                          },
                          (error) => {
                            Swal.fire({
                              text: "Un problème est survenu! " + error,
                            });

                            this.spinnercontact.hide();
                          }
                        );
                    }
                  });
                } else {
                  Swal.fire({
                    text: "Une erreur est survenue lors de la suppression",
                  });
                }
              },
              (error) => {
                Swal.fire({
                  text: "Un problème est survenu! " + error,
                });

                this.spinnercontact.hide();
              }
            );
        }
      });

  }

  submitUpdateForm() {
    if (this.registerFormContactupdate.invalid) {
      return;
    }
    //console.log('LKLK'+this.registerFormContactupdate.value);

    Object.values(this.registerFormContactupdate).forEach((val) => {
      //console.log(val);
    });
    this.submitStatus = true;
    this.contactListPost = true;
    this.spinnercontact.show();

    this.http
      .put(
        environment.apiUrl + "/contacts/" + this.selectedRowIndex,
        this.registerFormContactupdate.value
      )
      .subscribe(
        (data) => {
          //console.log(data)

          var resp: any = data;
          if (resp.status == 200) {
            this.spinnercontact.hide();
            this.contactListPost = false;

            Swal.fire({
              position: "center",
              title: "Modification enregistré avec succès!",
              showConfirmButton: false,
              timer: 1000,
            });
            let ref = document.getElementById('cancel-edit')
            ref?.click()
            this.getContact(15,1);
          } else {
            this.spinnercontact.hide();
            this.contactListPost = false;

            Swal.fire({
              text: resp.message.join("<br>"),
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });

          this.spinnercontact.hide();
        }
      );
  }

  displayedColumns: string[] = [
    "select",
    "first_name",
    "last_name",
    "email",
    "delete",
    "action",
  ];

  pipe: DatePipe;

  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });

  get fromDate() {
    return this.filterForm.get("fromDate").value;
  }
  get toDate() {
    return this.filterForm.get("toDate").value;
  }

  rangeFormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  rangeFormGroup2 = new FormGroup({
    dt10: new FormControl(),
  });

  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    public traslateService: TraslateService,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private spinnercontact: NgxSpinnerService,
    private dialog : MatDialog,
    private cdRef:ChangeDetectorRef

  ) {
    this.series1 = [];
    this.traslateService.obs.subscribe((response) => {
      this.traslateService.maptoAtelier(response, this.series1);
    });

    // this.getContact(1, 1);
  }

  openSnackBar() {
    this._snackBar.open("Cannonball!!", "End now", {
      duration: 500,
    });
  }

  applyFilterr() {
    this.dataSource.filter = "" + Math.random();
  }

  updateColor(progress) {
    if (progress < 55) {
      return "#dc3545";
    } else if (progress > 75) {
      return "#28a745";
    } else {
      return "#fd8021";
    }
  }

  selectedRowIndex = -1;

  add(addContact) {
    this.showedit = false;
    this.showadd = true;
    this.modif_cancel();
    this.dialog.open(addContact,{
      height:'520px',
      width:'700px'
    })
  }


  canceladd_edit() {
    this.showadd = false;
    this.showedit = false;
  }

  cancel_edit() {
    this.showadd = false;
    this.showedit = false;
    this.selectedRowIndex = null;
    this.first_name = "";
    this.last_name = "";

    this.gsm_number = "";
    this.email = "";
  }


  edit(editContact) {
    this.dialog.open(editContact,{
      height:'520px',
      width:'700px'
    })
  }
  onClose(){

  }

  // supprimerItem(e) {
  //   this.itemSelect = e;
  //   this.selectedRowIndex = e.id;
  //   this.Delete_contact()
  //
  // }
  supprimerItem(operation, id: any,) {
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push({
        id: id,
      })
      console.log("list", this.listItems)
    }
    for (var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
      this.reseller_id = this.listItems[i].reseller_id;
    }
    Swal.fire({
      title: "Voulez-vous supprimer ce contact?",
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.partnercompanyrevendeur = true
        this.partnercompany = true
        //this.spinnerusercompany.show();
        this.http.delete(environment.apiUrl + "/contacts/" +JSON.stringify(this.arr)).subscribe((response) => {
          // this.getgogo()
          this.listItems = []
          this.arr = []
          this.selection.clear();
          this.getContact(15,1)
          this.partnercompany = false
          this.selection.clear();
          this.hiddenItemClick = 0

        })
      } else {
        this.arr = []
        this.listItems = []
        this.selection.clear()
      }
    })
  }
  getgogo() {
    this.hiddenItemClick = this.selection.selected.length
    console.log("bezzzzzz",this.hiddenItemClick, 'hgjh' + JSON.stringify(this.selection.selected))
    this.selection.selected.forEach(element => {
      this.idSelected = element.id;
      this.nameSelected = element.name
    });
    console.log("mouaaaaaahhh",this.idSelected + 'lkjlkjlk')
  }
  modifierItem(e,editContact) {
    this.itemSelect = e;
    this.selectedRowIndex = e.id;
    this.hiddenDetails = true;
    this.last_name = e.last_name;
    this.first_name = e.first_name;
    this.gsm_number = e.gsm_number;
    this.email = e.email;
     this.selection.clear();
    this.edit(editContact)
  }

  selectedRowIndex2 = -1;

  getItemDetails2(e) {
    this.itemSelect2 = e.forks;
    this.selectedRowIndex2 = e.id;
    this.hiddenContenu = "jkhjk";
  }
  gettbldetils() {
    this.tblhidden = "true";
  }
  gettbldetilsd() {
    this.tblhidden = "jjj";
  }
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput
        .split(",")
        .map((str) => +str);
    }
  }

  public updateManualPage(index): void {
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  collection: any;

  public updateManualPage2(index2): void {
    this.collection = [];
    this.paginator.pageSize = index2;
    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });

    this.lengthpage = parseInt("" + this.paginator.length / index2);
    if (this.lengthpage % 2 == 0) {
      for (var i = 0; i < this.lengthpage; i++) {
        this.collection.push(i + 1);
      }
    } else {
      for (var i = 0; i < this.lengthpage + 1; i++) {
        this.collection.push(i + 1);
      }
    }
  }

  applyFilterer(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filtre = filterValue.trim().toLowerCase();
    this.getContact(15, 1)
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous exporter la table type ." + e2 + " ?",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Exporter Fichier !",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Export!", "Le fichier est exporté."
);        e.exportTable(e2, {
          fileName: "STG_DRIVE_Evenement_date_" + new Date().toLocaleString(),
          sheet: "STG DRIVE Evenement",
          Props: { Author: "STG_DRIVE" },
        });
      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire("Annuler", "Fichier non exporté !!");
      }
    });
  }

  exportTable() {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Démarrer l\'exportation",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        ContactsUtils.exportToPdf("ExampleTable", "tbl");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annuler", "  'Fichier non exporté !!");
      }
    });
  }
}

export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  weight1: number;
  weight2: number;
  pushed_at: Date;
  created_at: Date;
}
function addContact(addContact: any) {
  throw new Error("Function not implemented.");
}

